import React, { useEffect, useRef } from "react";
import "./PapayaMenu.scss"
import MenuLayout from "../components/MenuLayout/MenuLayout";
import { sortByOrderAscending } from "../helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../redux/companyDataSlice";
import CustomVideoPlayer from "../components/CustomVideoPlayer/CustomVideoPlayer";
const PapayaMenu = () => {

    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const pages = useSelector((state) => state.companyData.pages)
    const dispatch = useDispatch()
    const page = pages.find((page) => page.PageId === "menu")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "PapayaMenu-Hero-header":
                return <div className="PapayaMenu-Hero-header">
                    {component?.Props?.text}
                </div>
            case "PapayaMenu-Hero-subheader":
                return <div className="PapayaMenu-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="PapayaMenu-Hero"
                style={{
                    backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getMenuComponent = (component, props) => {
        switch (component.ID) {
            case "PapayaMenu-Content-header":
                return <div className="PapayaMenu-Content-header">
                    {component?.Props?.header} <span> {component?.Props?.headerHighlight}</span>
                </div>
            case "PapayaMenu-Content-subheader":
                return <div className="PapayaMenu-Content-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaMenu-Content-content":
                return <div className="PapayaMenu-Content-content">
                    {component?.Props?.text}
                </div>
            case "PapayaMenu-Content-grid":
                return <div className={props?.layout === "layout2" ? "PapayaMenu-Content-grid2" : "PapayaMenu-Content-grid"}>
                    {component?.Data.map((data, key) => {
                        return (
                            <MenuLayout
                                key={key}
                                data={data}
                                layout={component?.Props?.layout} />
                        )
                    })}
                </div>
            case "PapayaMenu-Content-btn":
                return <div className="PapayaMenu-Content-fullmenuButton"
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                            window.open(component?.Props?.href, '_blank')
                        } else {
                            dispatch(setIsComing(true))
                        }
                    }}>
                    {component?.Props?.btnText}
                </div>
            default:
                return <div />
        }

    }
    const getMenuContent = (components) => {
        return (
            <div className="PapayaMenu-Content">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getMenuComponent(component)
                    )
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="PapayaMenu-ImageCarousel" ref={containerRef}>
                <div className="PapayaMenu-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        data?.src.includes(".mp4") ?
                            <CustomVideoPlayer
                                src={data?.src} /> :
                            <img key={index} src={data?.src} alt={`img-${index}`} className="PapayaMenu-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "PapayaMenu-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "PapayaMenu-Content":
                return getMenuContent(component.Components, component?.Props)
            case "PapayaMenu-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="PapayaMenu">
            {sortByOrderAscending(Components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default PapayaMenu